import React from "react";
import copy from 'copy-to-clipboard';
import ContactPresenter from "./ContactPresenter";
import { useScrollTop } from '../../hooks';

const ContactContainer = () => {

  const handleCopy = ( text ) => {
    copy(text, {
      onCopy: () => {
        // console.log('Copied to clipboard');
      },
      onError: () => {
        // console.log('Failed to copy');
      }
    });
  };

  const handleAddressClick = () => {
    const place = "코리아매니지먼트그룹";
    const kakaoMapUrl = `https://map.kakao.com/link/search/${encodeURIComponent(place)}`;
    window.open(kakaoMapUrl, '_blank', 'noopener,noreferrer');
  };

  useScrollTop();
  return <ContactPresenter handleCopy={handleCopy} handleAddressClick={handleAddressClick} />;
};

export default ContactContainer;
